import * as poolActions from '../actions/pools';
import _ from 'lodash';
import update from 'immutability-helper';

function pools(state = {
    isFetching: false,
    afterJoin: false,
    pools: {},
    otherBets: {},
    games: {},
    bets: {},
    participates: {},
    goals: {},
    goalsLogByPool: {},
    goalsLogError: null,
    poolPreviewById: {},
    poolPreviewLoading: false,
    poolPreviewError: null,
    standingsByPoolId: {},
    standingsErrorByPoolId: {}
}, action) {
    switch (action.type) {
        case poolActions.GET_USER_POOLS_REQUEST:
            return update(state, {errorMessage: {$set: null}});
        case poolActions.GET_USER_POOLS_SUCCESS:
            return update(state, {
                isFetching: {$set: false},
                pools: {$set: _.keyBy(action.pools, 'poolId')},
                errorMessage: {$set: null}
            });
        case poolActions.GET_USER_POOLS_FAILURE:
            return update(state, { isFetching: { $set: false }, pools: { $set: [] }, errorMessage: { $set: action.message } });
        case poolActions.GET_POOL_GAMES_REQUEST:
            return update(state, { isFetching: { $set: true }, errorMessage: { $set: null } });
        case poolActions.GET_POOL_GAMES_SUCCESS:
            return update(state, {isFetching: {$set: false}, games: {$set:_.keyBy(action.games, 'id')}, errorMessage: {$set: null}});
        case poolActions.UPDATE_CHALLEGE_SUCCESS: {
            const {id: challengeId, score1, score2, status, isOpen} = action.challenge;
            const bet = _.cloneDeep(_.get(state.bets, challengeId));
            if (bet) {
                const {score1: prevScore1, score2: prevScore2} = bet.challenge;
                let side = null;
                if (prevScore1 !== score1 && score1 > 0) {
                    side = 'homeTeam';
                }
                if (prevScore2 !== score2 && score2 > 0) {
                    side = 'awayTeam';
                }
                bet.challenge = _.assign({}, bet.challenge , {score1, score2, status, isOpen});
                return update(state, {
                    isFetching: {$set: false},
                    goals: side !== null ? {$merge: {[challengeId]: side}} :  {$unset: [challengeId]} ,
                    bets: {$merge: {[challengeId]: bet}},
                    errorMessage: {$set: null}
                });
            }
            return update(state, {isFetching: {$set: false}, errorMessage: {$set: null}});
        }
        case poolActions.CLEAR_GOAL_ANIMA: {
            const clearId = action.challengeId;
            return update(state , {goals:{$unset: [clearId]}});
        }
        case poolActions.GET_USER_BETS_REQUEST:
            return update(state, { isFetching: { $set: true }, errorMessage: { $set: null } });
        case poolActions.GET_USER_BETS_SUCCESS:
            return update(state, { isFetching: { $set: false }, bets: { $set: _.keyBy(action.bets, 'challenge.id') }, errorMessage: { $set: null } });
        case poolActions.GET_POOL_PARTICIPATES_REQUEST:
            return update(state, { isFetching: { $set: true }, otherBets: { $set: {} }, errorMessage: { $set: null } });
        case poolActions.GET_CHALLENGE_PARTICIPATES_REQUEST:
            return update(state, { isFetching: { $set: true }, otherBets: { $set: {} }, errorMessage: { $set: null } });
        case poolActions.GET_POOL_PARTICIPATES_SUCCESS:
            return update(state, { isFetching: { $set: false }, participates: { $set: action.participates }, errorMessage: { $set: null } });
        case poolActions.JOIN_TO_POOL_SUCCESS:
            return update(state, { isFetching: { $set: false }, afterJoin: { $set: true }, pools: { $merge: { [action.poolId]: action.pool } }, participates: { $set: action.participates }, errorMessage: { $set: null } });
        case poolActions.GET_CHALLENGE_PARTICIPATES_SUCCESS:
            return update(state, { isFetching: { $set: false }, otherBets: { $merge: { challenge: action.challenge, usersBets: action.usersBets } }, errorMessage: { $set: null } });
        case poolActions.UPDATE_USER_BET_REQUEST:
            return update(state, { isFetching: { $set: true }, errorMessage: { $set: null } });
        case poolActions.UPDATE_USER_BET_SUCCESS:
            return update(state, {
                isFetching: { $set: false },
                bets: { $merge: { [action.challengeId]: action.bet } },
                errorMessage: { $set: null } });
        case poolActions.UPDATE_USER_BET_FAILURE:
            return update(state, { isFetching: { $set: false }, errorMessage: { $set: action.message } });
        case poolActions.UPDATE_USER_BETS_REQUEST:
            return update(state, { isFetching: { $set: true }, errorMessage: { $set: null } });
        case poolActions.UPDATE_USER_BETS_SUCCESS:
            return update(state, {isFetching: {$set: false, bets: {$set: action.bets}, errorMessage: {$set: null}}});
        case poolActions.UPDATE_USER_BETS_FAILURE:
            return update(state, { isFetching: { $set: false }, errorMessage: { $set: action.message } });
        case poolActions.GET_POOL_GOALS_SUCCESS:
            return update(state, {
                goalsLogByPool: {$merge: {[String(action.poolId)]: action.entries}},
                goalsLogError: {$set: null},
                errorMessage: {$set: null}
            });
        case poolActions.GET_POOL_GOALS_FAILURE:
            return update(state, {goalsLogError: {$set: action.message}});
        case poolActions.GET_POOL_PREVIEW_REQUEST:
            return update(state, {
                poolPreviewLoading: {$set: true},
                poolPreviewError: {$set: null}
            });
        case poolActions.GET_POOL_PREVIEW_SUCCESS:
            return update(state, {
                poolPreviewLoading: {$set: false},
                poolPreviewError: {$set: null},
                poolPreviewById: {$merge: {[String(action.poolId)]: action.preview}}
            });
        case poolActions.GET_POOL_PREVIEW_FAILURE:
            return update(state, {
                poolPreviewLoading: {$set: false},
                poolPreviewError: {$set: action.message}
            });
        case poolActions.CLEAR_POOL_PREVIEW:
            return update(state, {poolPreviewById: {$unset: [String(action.poolId)]}});
        case poolActions.GET_POOL_STANDINGS_SUCCESS:
            return update(state, {
                standingsByPoolId: {$merge: {[String(action.poolId)]: action.standings}},
                standingsErrorByPoolId: {$unset: [String(action.poolId)]}
            });
        case poolActions.GET_POOL_STANDINGS_FAILURE:
            return update(state, {
                standingsErrorByPoolId: {$merge: {[String(action.poolId)]: action.message}}
            });
        default:
            return state;
    }
}

export default pools;